var map = {
	"./3d-speech-bubble.png": 660,
	"./817w2.png": 178,
	"./817w3.png": 179,
	"./9881.png": 661,
	"./9882.png": 662,
	"./Artboard 20 1.svg": 663,
	"./Artboard 20 2.svg": 664,
	"./Boss-right.png": 665,
	"./CSRealCase1-en-moblie.jpg": 215,
	"./CSRealCase1-en.jpg": 216,
	"./CSRealCase1-moblie.jpg": 217,
	"./CSRealCase1.jpg": 218,
	"./CSRealCase1.png": 666,
	"./CSRealCase2-en-moblie.jpg": 219,
	"./CSRealCase2-en.jpg": 220,
	"./CSRealCase2-moblie.jpg": 221,
	"./CSRealCase2.jpg": 222,
	"./CSRealCase3-en-moblie.jpg": 223,
	"./CSRealCase3-en.jpg": 224,
	"./CSRealCase3-moblie.jpg": 225,
	"./CSRealCase3.jpg": 226,
	"./CommonInternetWhalingAttacks1.jpg": 227,
	"./CommonInternetWhalingAttacks1.png": 667,
	"./CommonInternetWhalingAttacks2.jpg": 228,
	"./CommonInternetWhalingAttacks2.png": 668,
	"./CommonInternetWhalingAttacks3.jpg": 229,
	"./CommonInternetWhalingAttacks3.png": 669,
	"./CommonInternetWhalingAttacks4.jpg": 230,
	"./CommonInternetWhalingAttacks4.png": 670,
	"./CustomerRealCase1-en-moblie.jpg": 231,
	"./CustomerRealCase1-en.jpg": 232,
	"./CustomerRealCase1-moblie.jpg": 233,
	"./CustomerRealCase1.jpg": 234,
	"./E-commerce-gif1.gif": 671,
	"./E-commerce-gif2.gif": 672,
	"./E-commerce-gif3.gif": 673,
	"./E-commerce-gif4.gif": 674,
	"./E-commerceRealCase1-en.jpg": 235,
	"./E-commerceRealCase1-moblie-en.jpg": 236,
	"./E-commerceRealCase1-moblie.jpg": 237,
	"./E-commerceRealCase1.jpg": 238,
	"./E-commerceRealCase2-en.jpg": 239,
	"./E-commerceRealCase2-mobile.jpg": 240,
	"./E-commerceRealCase2-moblie-en.jpg": 241,
	"./E-commerceRealCase2-moblie.jpg": 242,
	"./E-commerceRealCase2.jpg": 243,
	"./Finance.png": 180,
	"./FinanceRealCase-en.jpg": 244,
	"./FinanceRealCase-mobile-en.jpg": 245,
	"./FinanceRealCase-mobile-sc.jpg": 246,
	"./FinanceRealCase-mobile.jpg": 247,
	"./FinanceRealCase-sc.jpg": 248,
	"./FinanceRealCase.jpg": 249,
	"./FinanceRealCase.png": 675,
	"./FinanceRealCase2-en.jpg": 250,
	"./FinanceRealCase2-mobile-en.jpg": 251,
	"./FinanceRealCase2-mobile-sc.jpg": 252,
	"./FinanceRealCase2-mobile.jpg": 253,
	"./FinanceRealCase2-sc.jpg": 254,
	"./FinanceRealCase2.jpg": 255,
	"./G5584.png": 676,
	"./Group5600.png": 677,
	"./HRRealCase-en.jpg": 256,
	"./HRRealCase-mobile-en.jpg": 257,
	"./HRRealCase-mobile.jpg": 258,
	"./HRRealCase.jpg": 259,
	"./IT.png": 181,
	"./ITRealCase.svg": 678,
	"./ITRealCase1-en.jpg": 260,
	"./ITRealCase1-moblie-en.jpg": 261,
	"./ITRealCase1-moblie.jpg": 262,
	"./ITRealCase1.jpg": 263,
	"./ITRealCase2-en.jpg": 264,
	"./ITRealCase2-moblie-en.jpg": 265,
	"./ITRealCase2-moblie.jpg": 266,
	"./ITRealCase2.jpg": 267,
	"./ITRealCase3-en.jpg": 268,
	"./ITRealCase3-moblie-en.jpg": 269,
	"./ITRealCase3-moblie.jpg": 270,
	"./ITRealCase3.jpg": 271,
	"./IndexPrompt.jpg": 272,
	"./IndexPrompt.png": 679,
	"./Introduction.png": 680,
	"./Lady.svg": 681,
	"./Link.png": 109,
	"./Ma009-1.svg": 682,
	"./Ma009-2.svg": 683,
	"./Ma009-3.svg": 684,
	"./Ma009-4.svg": 685,
	"./Ma009-5.svg": 686,
	"./Ma009-6.svg": 687,
	"./Manufacturing.png": 688,
	"./MarketRealCase.jpg": 273,
	"./MarketRealCase1-en-moblie.jpg": 274,
	"./MarketRealCase1-en.jpg": 275,
	"./MarketRealCase1-moblie.jpg": 276,
	"./MarketRealCase1.jpg": 277,
	"./MarketRealCase1.png": 689,
	"./MarketRealCase1.svg": 690,
	"./MarketRealCase2-en-moblie.jpg": 278,
	"./MarketRealCase2-en.jpg": 279,
	"./MarketRealCase2-moblie.jpg": 280,
	"./MarketRealCase2.jpg": 281,
	"./MarketRealCase3-en.jpg": 282,
	"./Mc001-Picture1.png": 691,
	"./Mc001-Picture2.png": 692,
	"./Mc001-Picture3.png": 693,
	"./NGORealCase1-en.jpg": 283,
	"./NGORealCase1-moblie-en.jpg": 284,
	"./NGORealCase1-moblie.jpg": 285,
	"./NGORealCase1.jpg": 286,
	"./NGORealCase2-en.jpg": 287,
	"./NGORealCase2-moblie-en.jpg": 288,
	"./NGORealCase2-moblie.jpg": 289,
	"./NGORealCase2.jpg": 290,
	"./PPII.png": 694,
	"./Pictureds1.png": 695,
	"./Pictureds10.png": 696,
	"./Pictureds2.png": 697,
	"./Pictureds3.png": 698,
	"./Pictureds4.png": 699,
	"./Pictureds5.png": 700,
	"./Pictureds6.png": 701,
	"./Pictureds7.png": 702,
	"./Pictureds8.png": 703,
	"./Pictureds9.png": 704,
	"./PwC_Repre_Illus_Iso_02_IoT_RGB.png": 705,
	"./PwC_Repre_Illus_Iso_05_Chatbot_RGB.png": 706,
	"./RealCase-en.png": 707,
	"./RealCase-mobile-en.jpg": 291,
	"./RealCase-mobile-sc.jpg": 292,
	"./RealCase-sc.jpg": 293,
	"./RealCase.mobile.jpg": 294,
	"./RealCase.png": 708,
	"./Realcase-socialMedia-en.png": 709,
	"./Realcase-socialMedia-mobile-en.png": 710,
	"./Realcase-socialMedia-mobile.jpg": 295,
	"./Realcase-socialMedia.jpg": 296,
	"./Shield.png": 182,
	"./Software-Downloading-icon1.png": 711,
	"./Software-Downloading-icon2.png": 712,
	"./Software-Downloading-icon3.png": 713,
	"./Software-Downloading-icon4.png": 714,
	"./Software-Downloading-img1.png": 715,
	"./Software-Downloading-img2.png": 716,
	"./Software-Downloading-img3.png": 717,
	"./Software-Downloading-img4.png": 718,
	"./a001-01.svg": 719,
	"./a001-02.svg": 720,
	"./a001-03.svg": 721,
	"./a001-04.svg": 722,
	"./a001-05.svg": 723,
	"./a001-06.svg": 724,
	"./a001-ransomware-01.png": 725,
	"./a001-ransomware-02.png": 726,
	"./a001-ransomware-03.png": 727,
	"./a001-ransomware-04.png": 728,
	"./a001-whatsapp-01.png": 729,
	"./a001-whatsapp-02.png": 730,
	"./a001-whatsapp-03.png": 731,
	"./a004-a.jpg": 297,
	"./a004-b.jpg": 298,
	"./a004-example1-en.jpg": 299,
	"./a004-example1-sc.jpg": 300,
	"./a004-example1.jpg": 301,
	"./a004-example2.jpg": 302,
	"./a004-example3.jpg": 303,
	"./a004-mary-left.svg": 732,
	"./a005-5.png": 733,
	"./a005-6.png": 734,
	"./a005-general2024.png": 735,
	"./a006-a.png": 736,
	"./a006-b.png": 737,
	"./a006-c.png": 738,
	"./a008-1.png": 739,
	"./a008-1.svg": 740,
	"./a008-2.png": 741,
	"./a008-2.svg": 742,
	"./a008-3.png": 743,
	"./a008-3.svg": 744,
	"./a008-4.png": 745,
	"./a008-4.svg": 746,
	"./a008-5.png": 747,
	"./a008-5.svg": 748,
	"./a008-6.svg": 749,
	"./a008-7.svg": 750,
	"./a008-A.svg": 751,
	"./a008-B.svg": 752,
	"./a008-C.svg": 753,
	"./a008-D.svg": 754,
	"./a008-tip.jpg": 304,
	"./a009-1.png": 755,
	"./a009-1.svg": 756,
	"./a009-2.png": 757,
	"./a009-2.svg": 758,
	"./a009-3.png": 759,
	"./a009-3.svg": 760,
	"./a009-4.png": 761,
	"./a009-4.svg": 762,
	"./a009-5.svg": 763,
	"./a009-6.svg": 764,
	"./a009-ransomware-01.svg": 765,
	"./a009-ransomware-02.svg": 766,
	"./a009-ransomware-03.svg": 767,
	"./a009-ransomware-04.svg": 768,
	"./a009-tip1.jpg": 305,
	"./a009-tip2.jpg": 306,
	"./a009-tip3.jpg": 307,
	"./a010-1.png": 769,
	"./a010-2.png": 770,
	"./a010-3.png": 771,
	"./a010-4.png": 772,
	"./a011-01.jpg": 308,
	"./a011-010.jpg": 309,
	"./a011-011.jpg": 310,
	"./a011-012.jpg": 311,
	"./a011-02.jpg": 312,
	"./a011-03.jpg": 313,
	"./a011-04.jpg": 314,
	"./a011-05.jpg": 315,
	"./a011-06.jpg": 316,
	"./a011-07.jpg": 317,
	"./a011-08.jpg": 318,
	"./a011-09.jpg": 319,
	"./a011-1.png": 773,
	"./a011-1.svg": 774,
	"./a011-2.png": 775,
	"./a011-2.svg": 776,
	"./a011-3.png": 777,
	"./a011-3.svg": 778,
	"./a011-4.png": 779,
	"./a011-4.svg": 780,
	"./a011-5.png": 781,
	"./a011-5.svg": 782,
	"./a011-6.png": 783,
	"./a011-6.svg": 784,
	"./a011-7.svg": 785,
	"./a011-PPII-1.svg": 786,
	"./a011-PPII-2.svg": 787,
	"./a011-PPII-3.svg": 788,
	"./a011-PPII-4.svg": 789,
	"./a011-PPII-5.svg": 790,
	"./a011-PPII-6.svg": 791,
	"./a011-example1.jpg": 320,
	"./a011-example10.png": 792,
	"./a011-example11_en.png": 793,
	"./a011-example11_sc.png": 794,
	"./a011-example11_tc.png": 795,
	"./a011-example13_en.png": 796,
	"./a011-example13_sc.png": 797,
	"./a011-example13_tc.png": 798,
	"./a011-example2.jpg": 321,
	"./a011-example3.jpg": 322,
	"./a011-example4.png": 799,
	"./a011-example5.jpg": 323,
	"./a011-example6.jpg": 324,
	"./a011-example7.jpg": 325,
	"./a011-example8.jpg": 326,
	"./a011-example9.png": 800,
	"./a011-fsi-01.svg": 801,
	"./a011-fsi-02.svg": 802,
	"./a011-fsi-03.svg": 803,
	"./a011-fsi-04.svg": 804,
	"./a011-fsi-05.svg": 805,
	"./a011-fsi-06.svg": 806,
	"./a011-fsi-07.svg": 807,
	"./a011-fsi-08.svg": 808,
	"./a011-fsi-09.svg": 809,
	"./a011-fsi-10.svg": 810,
	"./a011-general2024-example1.png": 811,
	"./a011-general2024-example2.png": 812,
	"./a011-general2024-example3.png": 813,
	"./a011-general2024-example4.png": 814,
	"./a011-market-1.svg": 815,
	"./a011-market-2.svg": 816,
	"./a011-market-3.svg": 817,
	"./a011-market-4.svg": 818,
	"./a011-market-5.svg": 819,
	"./a011-market-6.svg": 820,
	"./a011-startup-01.svg": 821,
	"./a011-startup-02.svg": 822,
	"./a011-startup-03.svg": 823,
	"./a011-startup-04.svg": 824,
	"./a011-startup-05.svg": 825,
	"./a011-startup-06.svg": 826,
	"./a011-startup-1.svg": 827,
	"./a011-startup-2.svg": 828,
	"./a011-startup-3.svg": 829,
	"./a011-startup-4.svg": 830,
	"./a011-startup-5.svg": 831,
	"./a012-1.png": 832,
	"./a012-1.svg": 833,
	"./a012-10.png": 834,
	"./a012-10.svg": 835,
	"./a012-11.png": 836,
	"./a012-12.png": 837,
	"./a012-13.png": 838,
	"./a012-14.png": 839,
	"./a012-15.png": 840,
	"./a012-2.png": 841,
	"./a012-2.svg": 842,
	"./a012-3.png": 843,
	"./a012-3.svg": 844,
	"./a012-4.png": 845,
	"./a012-4.svg": 846,
	"./a012-5.png": 847,
	"./a012-5.svg": 848,
	"./a012-6.png": 849,
	"./a012-6.svg": 850,
	"./a012-7.png": 851,
	"./a012-7.svg": 852,
	"./a012-8.png": 853,
	"./a012-8.svg": 854,
	"./a012-9.png": 855,
	"./a012-9.svg": 856,
	"./a012-market-1.svg": 857,
	"./a012-market-10.svg": 858,
	"./a012-market-2.svg": 859,
	"./a012-market-3.svg": 860,
	"./a012-market-4.svg": 861,
	"./a012-market-5.svg": 862,
	"./a012-market-6.svg": 863,
	"./a012-market-7.svg": 864,
	"./a012-market-8.svg": 865,
	"./a012-market-9.svg": 866,
	"./a012-market-line-1.svg": 867,
	"./a012-market-line-10.svg": 868,
	"./a012-market-line-2.svg": 869,
	"./a012-market-line-3.svg": 870,
	"./a012-market-line-4.svg": 871,
	"./a012-market-line-5.svg": 872,
	"./a012-market-line-6.svg": 873,
	"./a012-market-line-7.svg": 874,
	"./a012-market-line-8.svg": 875,
	"./a012-market-line-9.svg": 876,
	"./a013-1.png": 877,
	"./a013-2.png": 878,
	"./a013-3.png": 879,
	"./a013-4.png": 880,
	"./a013-a.png": 881,
	"./a013-b.png": 882,
	"./a013-c.png": 883,
	"./a013-d.png": 884,
	"./a014-long.svg": 885,
	"./a014-longer.svg": 886,
	"./a014.svg": 887,
	"./a015-1.svg": 888,
	"./a015-2.svg": 889,
	"./a015-3.svg": 890,
	"./a015-4.svg": 891,
	"./a015-arrow.svg": 110,
	"./a016-1.jpg": 327,
	"./a016-2.jpg": 328,
	"./a016-3.jpg": 329,
	"./a016-4.jpg": 330,
	"./a016-4.png": 892,
	"./a016-5.jpg": 331,
	"./a016-5.png": 893,
	"./a016-6.jpg": 332,
	"./a016-6.png": 894,
	"./a016-7.png": 895,
	"./a016-8.png": 896,
	"./a016-attention-market.svg": 111,
	"./a016-attention.svg": 112,
	"./a016-market-1.jpg": 333,
	"./a016-market-2.jpg": 334,
	"./a016-market-3.jpg": 335,
	"./a016-market-4.jpg": 336,
	"./a017-1.svg": 897,
	"./a017-10.svg": 898,
	"./a017-2.svg": 899,
	"./a017-3.svg": 900,
	"./a017-4.svg": 901,
	"./a017-5.svg": 902,
	"./a017-6.svg": 903,
	"./a017-7.svg": 904,
	"./a017-8.svg": 905,
	"./a017-9.svg": 906,
	"./a017-a.svg": 907,
	"./a017-b.svg": 908,
	"./a017-c.svg": 909,
	"./a017-d.svg": 910,
	"./a017-e.svg": 911,
	"./a017-f.svg": 912,
	"./a017-g.svg": 913,
	"./a017-h.svg": 914,
	"./a017-i.svg": 915,
	"./a017-j.svg": 916,
	"./a017-line1.svg": 917,
	"./a017-line10.svg": 918,
	"./a017-line2.svg": 919,
	"./a017-line3.svg": 920,
	"./a017-line4.svg": 921,
	"./a017-line5.svg": 922,
	"./a017-line6.svg": 923,
	"./a017-line7.svg": 924,
	"./a017-line8.svg": 925,
	"./a017-line9.svg": 926,
	"./a017-market-1.svg": 927,
	"./a017-market-10.svg": 928,
	"./a017-market-2.svg": 929,
	"./a017-market-3.svg": 930,
	"./a017-market-4.svg": 931,
	"./a017-market-5.svg": 932,
	"./a017-market-6.svg": 933,
	"./a017-market-7.svg": 934,
	"./a017-market-8.svg": 935,
	"./a017-market-9.svg": 936,
	"./a018-1.svg": 937,
	"./a018-10.svg": 938,
	"./a018-2.svg": 939,
	"./a018-3.svg": 940,
	"./a018-4.svg": 941,
	"./a018-5.svg": 942,
	"./a018-6.svg": 943,
	"./a018-7.svg": 944,
	"./a018-8.svg": 945,
	"./a018-9.svg": 946,
	"./a019-1.svg": 947,
	"./a019-2.svg": 948,
	"./a019-3.svg": 949,
	"./a019-4.svg": 950,
	"./a019-5.svg": 951,
	"./a019-tip-en.jpg": 337,
	"./a019-tip.jpg": 338,
	"./a019.gif": 952,
	"./a020-cs-1.svg": 953,
	"./a020-cs-2.svg": 954,
	"./a020-cs-3.svg": 955,
	"./a020-cs-4.svg": 956,
	"./a020-it-1.svg": 957,
	"./a020-it-2.svg": 958,
	"./a020-it-3.svg": 959,
	"./a020-it-4.svg": 960,
	"./a020-market-1.svg": 961,
	"./a020-market-2.svg": 962,
	"./a020-market-3.svg": 963,
	"./a020-market-4.svg": 964,
	"./a020-ngo-1.svg": 965,
	"./a020-ngo-2.svg": 966,
	"./a020-ngo-3.svg": 967,
	"./a020-ngo-4.svg": 968,
	"./a020-ngo-5.svg": 969,
	"./a021-viewmore-en.jpg": 339,
	"./a021-viewmore-en.png": 970,
	"./a021-viewmore-fsi.jpg": 340,
	"./a021-viewmore.jpg": 341,
	"./a021-viewmore.png": 971,
	"./a022-market.svg": 972,
	"./a023-01.png": 342,
	"./a023-02.png": 343,
	"./a023-03.png": 344,
	"./a023-04.png": 345,
	"./a023-05.png": 346,
	"./a023-06.png": 347,
	"./a023-1.png": 348,
	"./a023-2.png": 349,
	"./a023-3.png": 350,
	"./a023-4.png": 351,
	"./a023-example1.png": 352,
	"./a023-example2.png": 353,
	"./a023-example3.png": 354,
	"./a023-fsi1-short.png": 355,
	"./a023-fsi2-short.png": 356,
	"./a023-fsi3-short.png": 357,
	"./a023-fsi4-short.png": 358,
	"./a023-fsi5-short.png": 359,
	"./a023-short1.jpg": 154,
	"./a023-short2.jpg": 155,
	"./a023-short3.jpg": 156,
	"./a023-short4.jpg": 157,
	"./a023-short5.jpg": 158,
	"./a023-short6.jpg": 159,
	"./a023-startup1-en-short.png": 360,
	"./a023-startup1-en.png": 361,
	"./a023-startup1-short.png": 362,
	"./a023-startup1.png": 363,
	"./a023-startup2-en-short.png": 364,
	"./a023-startup2-en.png": 365,
	"./a023-startup2-short.png": 366,
	"./a023-startup2.png": 367,
	"./a023-startup3-en-short.png": 368,
	"./a023-startup3-en.png": 369,
	"./a023-startup3-short.png": 370,
	"./a023-startup3.png": 371,
	"./a023-startup4-en-short.png": 372,
	"./a023-startup4-en.png": 373,
	"./a023-startup4-short.png": 374,
	"./a023-startup4.png": 375,
	"./a023-startup5-en-short.png": 376,
	"./a023-startup5-en.png": 377,
	"./a023-startup5-short.png": 378,
	"./a023-startup5.png": 379,
	"./a024-1.gif": 973,
	"./a024-1.svg": 974,
	"./a024-10.svg": 975,
	"./a024-11.svg": 976,
	"./a024-12.svg": 977,
	"./a024-2.gif": 978,
	"./a024-2.svg": 979,
	"./a024-3.svg": 980,
	"./a024-4.svg": 981,
	"./a024-5.svg": 982,
	"./a024-6.svg": 983,
	"./a024-7.svg": 984,
	"./a024-8.svg": 985,
	"./a024-9.svg": 986,
	"./a024-startup-1.svg": 987,
	"./a024-startup-2.svg": 988,
	"./a024-startup-3.svg": 989,
	"./a024-startup-4.svg": 990,
	"./a024-startup-5.svg": 991,
	"./a024-startup-6.svg": 992,
	"./a026-example1-en.png": 993,
	"./a026-example1.jpg": 380,
	"./a026-example2.jpg": 381,
	"./a026-example3.jpg": 382,
	"./a026-example4.jpg": 383,
	"./a026-example5.jpg": 384,
	"./a026-example6.jpg": 385,
	"./a026-example7.jpg": 386,
	"./a026-example8.png": 994,
	"./a028-1.png": 387,
	"./a028-1.svg": 995,
	"./a028-2.png": 388,
	"./a028-2.svg": 996,
	"./a028-3.png": 389,
	"./a028-3.svg": 997,
	"./a028-4.png": 390,
	"./a028-4.svg": 998,
	"./a028-5.png": 391,
	"./a028-5.svg": 999,
	"./a028-6.png": 392,
	"./a028-example1.jpg": 393,
	"./a028-example2.jpg": 394,
	"./a028-example3.jpg": 395,
	"./a033.png": 1000,
	"./a036-1.svg": 1001,
	"./a036-2.svg": 1002,
	"./a036-3.svg": 1003,
	"./a036-4.svg": 1004,
	"./a036-5.svg": 1005,
	"./a037-1.svg": 1006,
	"./a037-10.svg": 1007,
	"./a037-2.svg": 1008,
	"./a037-3.svg": 1009,
	"./a037-4.svg": 1010,
	"./a037-5.svg": 1011,
	"./a037-6.svg": 1012,
	"./a037-7.svg": 1013,
	"./a037-8.svg": 1014,
	"./a037-9.svg": 1015,
	"./a037-IDNumber-08.png": 1016,
	"./a037-a.jpg": 396,
	"./a037-address-02.png": 1017,
	"./a037-b.jpg": 397,
	"./a037-biometricData-10.png": 1018,
	"./a037-c.jpg": 398,
	"./a037-d.jpg": 399,
	"./a037-dateofBirth-05.png": 1019,
	"./a037-driverLicenseNumber-06.png": 1020,
	"./a037-e.jpg": 400,
	"./a037-emailAddress-04.png": 1021,
	"./a037-f.jpg": 401,
	"./a037-financialAccount-09.png": 1022,
	"./a037-g.jpg": 402,
	"./a037-h.jpg": 403,
	"./a037-i.jpg": 404,
	"./a037-j.jpg": 405,
	"./a037-k.jpg": 406,
	"./a037-l.jpg": 407,
	"./a037-m.jpg": 408,
	"./a037-n.jpg": 409,
	"./a037-name-01.png": 1023,
	"./a037-passportNumber-07.png": 1024,
	"./a037-phoneNumber-03.png": 1025,
	"./a037-student-1-en.png": 1026,
	"./a037-student-1-sc.png": 1027,
	"./a037-student-1.png": 1028,
	"./a037-student-2.png": 1029,
	"./a037-student-t3-1.svg": 1030,
	"./a037-student-t3-10.svg": 1031,
	"./a037-student-t3-2.svg": 1032,
	"./a037-student-t3-3.svg": 1033,
	"./a037-student-t3-4.svg": 1034,
	"./a037-student-t3-5.svg": 1035,
	"./a037-student-t3-6.svg": 1036,
	"./a037-student-t3-7.svg": 1037,
	"./a037-student-t3-8.svg": 1038,
	"./a037-student-t3-9.svg": 1039,
	"./a037-student-t3-s3-1.svg": 1040,
	"./a037-student-t3-s3-10.svg": 1041,
	"./a037-student-t3-s3-2.svg": 1042,
	"./a037-student-t3-s3-3.svg": 1043,
	"./a037-student-t3-s3-4.svg": 1044,
	"./a037-student-t3-s3-5.svg": 1045,
	"./a037-student-t3-s3-6.svg": 1046,
	"./a037-student-t3-s3-7.svg": 1047,
	"./a037-student-t3-s3-8.svg": 1048,
	"./a037-student-t3-s3-9.svg": 1049,
	"./a038-1.svg": 1050,
	"./a038-2.svg": 1051,
	"./a038-3.svg": 1052,
	"./a038-4.svg": 1053,
	"./a038-5.svg": 1054,
	"./a038-6.svg": 1055,
	"./a038-7.svg": 1056,
	"./a041-1.png": 1057,
	"./a041-2.png": 1058,
	"./a041-3.png": 1059,
	"./a041-4.png": 1060,
	"./a041-5.png": 1061,
	"./a041-fsi1-bottom.png": 1062,
	"./a041-fsi1-top.png": 1063,
	"./a041-fsi2-bottom.png": 1064,
	"./a041-fsi2-top.png": 1065,
	"./a041-fsi3-bottom.png": 1066,
	"./a041-fsi3-top.png": 1067,
	"./a041-fsi4-bottom.png": 1068,
	"./a041-fsi4-top.png": 1069,
	"./a041-fsi5-bottom.png": 1070,
	"./a041-fsi5-top.png": 1071,
	"./a044-1.png": 1072,
	"./a044-2.png": 1073,
	"./a044-3.png": 1074,
	"./a044-4.png": 1075,
	"./a044-5.png": 1076,
	"./a044-6.png": 1077,
	"./a046-1.png": 1078,
	"./a046-2.png": 1079,
	"./a046-3.png": 1080,
	"./a046-4.png": 1081,
	"./a046-5.png": 1082,
	"./a046-6.png": 1083,
	"./a047-icon1.png": 1084,
	"./a047-icon2.png": 1085,
	"./a047-icon3.png": 1086,
	"./a047-icon4.png": 1087,
	"./a047-icon5.png": 1088,
	"./a047-icon6.png": 1089,
	"./a047-icon7.png": 1090,
	"./a047-vector-purple.png": 1091,
	"./a047-vector-red.png": 1092,
	"./a047-vector.png": 1093,
	"./animation-arrow.gif": 67,
	"./animation-arrow10.gif": 1094,
	"./animation-arrow11.gif": 1095,
	"./animation-arrow12.gif": 1096,
	"./animation-arrow13.gif": 1097,
	"./animation-arrow2.gif": 1098,
	"./animation-arrow3.gif": 1099,
	"./animation-arrow4.gif": 1100,
	"./animation-arrow5.gif": 1101,
	"./animation-arrow6.gif": 1102,
	"./animation-arrow7.gif": 1103,
	"./animation-arrow8.gif": 1104,
	"./animation-arrow9.gif": 1105,
	"./animation-quiz.gif": 1106,
	"./animation004-1.png": 43,
	"./animation004-2.png": 1107,
	"./animation021-01.svg": 1108,
	"./animation021-02.svg": 1109,
	"./animation021-03.svg": 1110,
	"./animation021-04.svg": 1111,
	"./animation021-05.svg": 1112,
	"./animation021-06.svg": 1113,
	"./animation_password.gif": 1114,
	"./animation_password_en.gif": 1115,
	"./animation_point.gif": 3,
	"./arrow-left-long.png": 10,
	"./arrow-left.png": 92,
	"./arrow-right-long.png": 11,
	"./arrow-right.png": 93,
	"./arrow.png": 54,
	"./avater1.png": 1116,
	"./avater2.png": 1117,
	"./avater3.png": 1118,
	"./avater4.png": 1119,
	"./avater5.png": 1120,
	"./avater6.png": 47,
	"./avater7.png": 48,
	"./avater8.png": 1121,
	"./avater9.png": 1122,
	"./avaterStudent.svg": 1123,
	"./boss-right2.png": 1124,
	"./bp1.png": 1125,
	"./bp10.png": 1126,
	"./bp11.png": 1127,
	"./bp2.png": 1128,
	"./bp3.png": 1129,
	"./bp4.png": 1130,
	"./bp5.png": 1131,
	"./bp6.png": 1132,
	"./bp7.png": 1133,
	"./bp8.png": 1134,
	"./bp9.png": 1135,
	"./business-problem1-en.png": 1136,
	"./business-problem1-sc.png": 1137,
	"./business-problem1.png": 1138,
	"./business-problem2.gif": 1139,
	"./business-problem3.png": 1140,
	"./business-problem4-en.png": 1141,
	"./business-problem4.png": 1142,
	"./business-problem5-en.png": 1143,
	"./business-problem5-sc.png": 1144,
	"./business-problem5.png": 1145,
	"./c001-E-commerce-1.jpg": 410,
	"./c001-E-commerce-2.jpg": 411,
	"./c001-E-commerce-3.jpg": 412,
	"./c001-E-commerce-4.jpg": 413,
	"./c001-E-commerce-5.jpg": 414,
	"./c001-E-commerce-6.jpg": 415,
	"./c001-Picture1.jpg": 416,
	"./c001-Picture2.jpg": 417,
	"./c001-Picture3.jpg": 418,
	"./c001-fsi-1.jpg": 419,
	"./c001-fsi-2.jpg": 420,
	"./c001-fsi-3.jpg": 421,
	"./c001-fsi-4.jpg": 422,
	"./c001-general2024-1.png": 1146,
	"./c001-general2024-2.png": 1147,
	"./c001-general2024-3.png": 1148,
	"./c001-general2024-4.png": 1149,
	"./c001-general2024-5.png": 1150,
	"./c001-general2024-6.png": 1151,
	"./c001-general2024-7.png": 1152,
	"./c001-general2024-8.png": 1153,
	"./c001-ngo-1.jpg": 423,
	"./c001-ngo-2.jpg": 424,
	"./c001-ngo-3.jpg": 425,
	"./c001-ngo-4.jpg": 426,
	"./c001-ngo-5.jpg": 427,
	"./c001-student-1.jpg": 428,
	"./c001-student-2.jpg": 429,
	"./c001-student-3.jpg": 430,
	"./c001-student-4.jpg": 431,
	"./c001-student-5.jpg": 432,
	"./c001-student-6.jpg": 433,
	"./c001-student-7.jpg": 434,
	"./c001-student-8.jpg": 435,
	"./c002-1.png": 1154,
	"./c002-1.svg": 1155,
	"./c002-PPII-1.svg": 1156,
	"./c002-PPII-10.svg": 1157,
	"./c002-PPII-11.svg": 1158,
	"./c002-PPII-12.svg": 1159,
	"./c002-PPII-13.svg": 1160,
	"./c002-PPII-14.svg": 1161,
	"./c002-PPII-15.svg": 1162,
	"./c002-PPII-16.svg": 1163,
	"./c002-PPII-2.svg": 1164,
	"./c002-PPII-3.svg": 1165,
	"./c002-PPII-4.svg": 1166,
	"./c002-PPII-6.svg": 1167,
	"./c002-PPII-7.svg": 1168,
	"./c002-PPII-8.svg": 1169,
	"./c002-PPII-9.svg": 1170,
	"./c002-eCommerce.png": 1171,
	"./c002-example1.jpg": 436,
	"./c002-general2024-example1.jpg": 437,
	"./c002-pic.png": 1172,
	"./c002-whatsapp-01-en.png": 1173,
	"./c002-whatsapp-01.png": 1174,
	"./c002-whatsapp-02-en.png": 1175,
	"./c002-whatsapp-02.png": 1176,
	"./c003-man-left.png": 1177,
	"./c003-right-lady.png": 1178,
	"./c005-1.png": 1179,
	"./c005-10.png": 1180,
	"./c005-11.png": 1181,
	"./c005-12.png": 1182,
	"./c005-13.png": 1183,
	"./c005-2.png": 1184,
	"./c005-3.png": 1185,
	"./c005-4.png": 1186,
	"./c005-5.png": 1187,
	"./c005-6.png": 1188,
	"./c005-7.png": 1189,
	"./c005-8.png": 1190,
	"./c005-9.png": 1191,
	"./c005-arrow01.png": 183,
	"./c005-arrow02.png": 184,
	"./c005-whatsapp-01-en.png": 1192,
	"./c005-whatsapp-01.png": 1193,
	"./c005-whatsapp-02-en.png": 1194,
	"./c005-whatsapp-02.png": 1195,
	"./c005-whatsapp-03-en.png": 1196,
	"./c005-whatsapp-03.png": 1197,
	"./c006-1.jpg": 438,
	"./c006-2.jpg": 439,
	"./c006-3.jpg": 440,
	"./c006-4.jpg": 441,
	"./c006-5.gif": 1198,
	"./c006-5.jpg": 442,
	"./c006-6.gif": 1199,
	"./c006-6.jpg": 443,
	"./c006-a.jpg": 444,
	"./c006-b.jpg": 445,
	"./c006-b.png": 1200,
	"./c006-c.jpg": 446,
	"./c006-c.png": 1201,
	"./c006-d.jpg": 447,
	"./c007-1.jpg": 448,
	"./c007-bg.jpg": 449,
	"./c008-1.png": 1202,
	"./c008-2.png": 1203,
	"./c008-2.svg": 1204,
	"./c008-3.svg": 1205,
	"./c008-board.svg": 1206,
	"./c008-board1.svg": 1207,
	"./c010-1.png": 1208,
	"./c010-2.png": 1209,
	"./c010-3.png": 1210,
	"./c010-4.png": 1211,
	"./c013-1.png": 1212,
	"./c013-2.png": 1213,
	"./calendar.png": 185,
	"./can-do.png": 1214,
	"./can-do.svg": 1215,
	"./can-do1.png": 1216,
	"./can-not-do.png": 1217,
	"./ceritificate-background.png": 1218,
	"./cert/cert-E-commerce-HKIRC.jpg": 450,
	"./cert/cert-E-commerce-consumer.jpg": 451,
	"./cert/cert-E-commerce-hkgcsmeaa.jpg": 160,
	"./cert/cert-customer-HKIRC.jpg": 452,
	"./cert/cert-customer-consumer.jpg": 453,
	"./cert/cert-customer-hkgcsmeaa.jpg": 161,
	"./cert/cert-finance-HKIRC-sc.jpg": 454,
	"./cert/cert-finance-HKIRC.jpg": 455,
	"./cert/cert-finance-consumer-sc.jpg": 456,
	"./cert/cert-finance-consumer.jpg": 457,
	"./cert/cert-finance-hkgcsmeaa-sc.jpg": 162,
	"./cert/cert-finance-hkgcsmeaa.jpg": 163,
	"./cert/cert-fsi-HKIRC-sc.jpg": 458,
	"./cert/cert-fsi-HKIRC.jpg": 459,
	"./cert/cert-fsi-consumer-sc.jpg": 460,
	"./cert/cert-fsi-consumer.jpg": 461,
	"./cert/cert-fsi-hkgcsmeaa-sc.jpg": 164,
	"./cert/cert-fsi-hkgcsmeaa.jpg": 165,
	"./cert/cert-general-staff-HKIRC-sc.jpg": 462,
	"./cert/cert-general-staff-HKIRC.jpg": 463,
	"./cert/cert-general-staff-consumer-sc.jpg": 464,
	"./cert/cert-general-staff-consumer.jpg": 465,
	"./cert/cert-general-staff-hkgcsmeaa-sc.jpg": 166,
	"./cert/cert-general-staff-hkgcsmeaa.jpg": 167,
	"./cert/cert-general2024-HKIRC-sc.jpg": 466,
	"./cert/cert-general2024-HKIRC.jpg": 467,
	"./cert/cert-general2024-consumer-sc.jpg": 468,
	"./cert/cert-general2024-consumer.jpg": 469,
	"./cert/cert-general2024-hkgcsmeaa-sc.jpg": 123,
	"./cert/cert-general2024-hkgcsmeaa.jpg": 124,
	"./cert/cert-hr-HKIRC.jpg": 470,
	"./cert/cert-hr-consumer.jpg": 471,
	"./cert/cert-hr-hkgcsmeaa.jpg": 168,
	"./cert/cert-it-HKIRC.jpg": 472,
	"./cert/cert-it-consumer.jpg": 473,
	"./cert/cert-it-hkgcsmeaa.jpg": 169,
	"./cert/cert-market-HKIRC.jpg": 474,
	"./cert/cert-market-consumer.jpg": 475,
	"./cert/cert-market-hkgcsmeaa.jpg": 170,
	"./cert/cert-ngo-HKIRC.jpg": 476,
	"./cert/cert-ngo-consumer.jpg": 477,
	"./cert/cert-ngo-hkgcsmeaa.jpg": 171,
	"./cert/cert-senior-manager-HKIRC-sc.jpg": 478,
	"./cert/cert-senior-manager-HKIRC.jpg": 479,
	"./cert/cert-senior-manager-consumer-sc.jpg": 480,
	"./cert/cert-senior-manager-consumer.jpg": 481,
	"./cert/cert-senior-manager-hkgcsmeaa-sc.jpg": 172,
	"./cert/cert-senior-manager-hkgcsmeaa.jpg": 173,
	"./cert/cert-startup-HKIRC.jpg": 482,
	"./cert/cert-startup-consumer.jpg": 483,
	"./cert/cert-startup-hkgcsmeaa.jpg": 174,
	"./cert/cert-student-HKIRC-sc.jpg": 484,
	"./cert/cert-student-HKIRC.jpg": 485,
	"./cert/cert-student-consumer-sc.jpg": 486,
	"./cert/cert-student-consumer.jpg": 487,
	"./cert/cert-student-hkgcsmeaa-sc.jpg": 175,
	"./cert/cert-student-hkgcsmeaa.jpg": 176,
	"./chat.gif": 1219,
	"./component003-left.png": 26,
	"./component003-right.png": 27,
	"./component003Boss-left.png": 1220,
	"./component003Boss-right.png": 1221,
	"./component003Lady-right.png": 1222,
	"./component003Man-right.png": 1223,
	"./component003Student-right.svg": 1224,
	"./contacting.png": 1225,
	"./conversation-left.png": 20,
	"./conversation-right.png": 19,
	"./conversation-right2.png": 1226,
	"./courseLanding-PPII.png": 1227,
	"./courseLanding-dataLeakage.png": 1228,
	"./courseLanding-ransomware-mobile.png": 1229,
	"./courseLanding-ransomware.png": 1230,
	"./courseLanding-socialMedia.png": 1231,
	"./courseLanding-whatsApp.png": 1232,
	"./courses/Finance.png": 1233,
	"./courses/Finance2.png": 1234,
	"./courses/GeneralStaff_Background.svg": 1235,
	"./courses/HR.png": 1236,
	"./courses/HotTopic_Background.svg": 1237,
	"./courses/IndustrySector_Background.svg": 1238,
	"./courses/JobPosition_Background.svg": 1239,
	"./courses/Manufacturing.png": 1240,
	"./courses/Ransomeware.png": 1241,
	"./courses/Retails.png": 1242,
	"./courses/Senior.png": 1243,
	"./courses/course1.png": 1244,
	"./courses/course10.png": 1245,
	"./courses/course8.png": 1246,
	"./courses/gf-topic1.png": 1247,
	"./cover.png": 1248,
	"./cs-a009-1.svg": 1249,
	"./cs-a009-2.svg": 1250,
	"./cs-a009-3.svg": 1251,
	"./cs-a009-4.svg": 1252,
	"./cs-a009-5.svg": 1253,
	"./cs-a009-6.svg": 1254,
	"./cs-a018-1.svg": 1255,
	"./cs-a018-10.svg": 1256,
	"./cs-a018-11.svg": 1257,
	"./cs-a018-2.svg": 1258,
	"./cs-a018-3.svg": 1259,
	"./cs-a018-4.svg": 1260,
	"./cs-a018-5.svg": 1261,
	"./cs-a018-6.svg": 1262,
	"./cs-a018-7.svg": 1263,
	"./cs-a018-8.svg": 1264,
	"./cs-a018-9.svg": 1265,
	"./cs-c001-Picture1.png": 1266,
	"./cs-c001-Picture2.png": 1267,
	"./cs-c001-Picture3.png": 1268,
	"./cs-c001-Picture4.png": 1269,
	"./cs-c003-boss-right.svg": 1270,
	"./cs-c003-right.svg": 1271,
	"./cs-gif1.gif": 1272,
	"./cs-gif2.gif": 1273,
	"./cs-gif3.gif": 1274,
	"./cs-gif4.gif": 1275,
	"./cs-welcome.svg": 1276,
	"./cyber-phishing1.png": 1277,
	"./cyber-phishing2.png": 1278,
	"./cyber-phishing3.png": 1279,
	"./cyber-phishing4.png": 1280,
	"./dataLeakage.png": 1281,
	"./dataLeakageRealcase-mobile.png": 1282,
	"./dataLeakageRealcase.png": 1283,
	"./desk-clean-icon1.png": 1284,
	"./desk-clean-icon2.png": 1285,
	"./desk-clean-icon3.png": 1286,
	"./desk-clean-icon4.png": 1287,
	"./desk-clean-img1.png": 1288,
	"./desk-clean-img2.png": 1289,
	"./desk-clean-img3.png": 1290,
	"./desk-clean-img4.png": 1291,
	"./desk-clean1.png": 1292,
	"./desk-clean2.png": 1293,
	"./desk-clean3.png": 1294,
	"./desk-clean4.png": 1295,
	"./desk-clean5.png": 1296,
	"./equal-highlight.png": 186,
	"./equal.png": 187,
	"./filterArrow.svg": 188,
	"./finance-gif1.gif": 1297,
	"./finance-gif2.gif": 1298,
	"./finance-gif3.gif": 1299,
	"./finance-gif4.gif": 1300,
	"./finance-topic1.png": 1301,
	"./finance-topic2.png": 1302,
	"./finance-topic3.png": 1303,
	"./finance-topic4.png": 1304,
	"./flame-training.gif": 1305,
	"./fonts/02b3f97a-406d-43cb-885c-ba5233577cad.woff2": 1306,
	"./fonts/08b57253-2e0d-4c12-9c57-107f6c67bc49.woff2": 1307,
	"./fonts/08edde9d-c27b-4731-a27f-d6cd9b01cd06.woff": 1308,
	"./fonts/14d824a2-2a5c-4692-8e30-74f6e177b675.ttf": 1309,
	"./fonts/22c6282d-e7aa-406b-89dc-5176916a9c44.ttf": 1310,
	"./fonts/240c57a0-fdce-440d-9ce3-85e0cb56f470.woff2": 1311,
	"./fonts/2a34f1f8-d701-4949-b12d-133c1c2636eb.woff": 1312,
	"./fonts/418e7417-47f3-40a1-8817-519a566f9d82.eot": 1313,
	"./fonts/4c21ab66-1566-4a85-b310-fbc649985f88.eot": 1314,
	"./fonts/4cc8f5da-4e24-4929-8efb-866ffcb1fe7e.eot": 1315,
	"./fonts/522972a6-5867-47ae-82fc-a7cf9bd5d4d4.eot": 1316,
	"./fonts/556d95c6-2352-4272-9422-83d53f66cfa3.ttf": 1317,
	"./fonts/5640036d-d549-4f16-b31e-87da78d9e832.eot": 1318,
	"./fonts/7802e576-2ffa-4f22-a409-534355fbea79.woff": 1319,
	"./fonts/7b415a05-784a-4a4c-8c94-67e9288312f5.woff": 1320,
	"./fonts/7d63ccf8-e0ae-4dee-ad4d-bbc798aa5803.woff2": 1321,
	"./fonts/800da3b0-675f-465f-892d-d76cecbdd5b1.woff2": 1322,
	"./fonts/8f4a1705-214a-4dd0-80b8-72252c37e688.ttf": 1323,
	"./fonts/922917a9-4ca8-4c0b-b1bb-417b6ff0210e.ttf": 1324,
	"./fonts/93ce67e5-64e3-4a99-99a3-545f20c5beec.woff2": 1325,
	"./fonts/96b3a113-3e18-46f9-b6e3-5bdee7288b20.woff": 1326,
	"./fonts/b2c1327f-ab3d-4230-93d7-eee8596e1498.woff": 1327,
	"./fonts/cad33bbd-bbf2-423b-98c5-51136c054e14.woff": 1328,
	"./fonts/cb0d1e8a-e111-4dbf-82c2-e948aba954c0.eot": 1329,
	"./fonts/da266c3a-a094-4adc-a81e-12f73609ba16.eot": 1330,
	"./fonts/f07c25ed-2d61-4e44-99ab-a0bc3ec67662.ttf": 1331,
	"./fonts/f9c5199e-a996-4c08-9042-1eb845bb7495.woff2": 1332,
	"./fonts/fdf10d5e-4ce0-45e5-a6c1-5eaff6cb1c11.ttf": 1333,
	"./fsi1.gif": 1334,
	"./fsi2.gif": 1335,
	"./fsi3.gif": 1336,
	"./fsi4.gif": 1337,
	"./fsiRealCase1-en.jpg": 488,
	"./fsiRealCase1-mobile-en.jpg": 489,
	"./fsiRealCase1-mobile-sc.jpg": 490,
	"./fsiRealCase1-mobile.jpg": 491,
	"./fsiRealCase1-sc.jpg": 492,
	"./fsiRealCase1.jpg": 493,
	"./fsiRealCase2-en-mobile.jpg": 494,
	"./fsiRealCase2-en.jpg": 495,
	"./fsiRealCase2-mobile-sc.jpg": 496,
	"./fsiRealCase2-mobile.jpg": 497,
	"./fsiRealCase2-sc.jpg": 498,
	"./fsiRealCase2.jpg": 499,
	"./general2024-1.gif": 1338,
	"./general2024-2.gif": 1339,
	"./general2024-3.gif": 1340,
	"./general2024-4.gif": 1341,
	"./general2024RealCase1-en-mobile.jpg": 500,
	"./general2024RealCase1-en.jpg": 501,
	"./general2024RealCase1-mobile-sc.jpg": 502,
	"./general2024RealCase1-mobile.jpg": 503,
	"./general2024RealCase1-sc.jpg": 504,
	"./general2024RealCase1.jpg": 505,
	"./globe.png": 189,
	"./hacker-using-laptop.gif": 1342,
	"./hacker1-en.png": 1343,
	"./hacker1.png": 1344,
	"./hacker2-en.png": 1345,
	"./hacker2.png": 1346,
	"./hacker3-en.png": 1347,
	"./hacker3.png": 1348,
	"./happy-emoji.png": 94,
	"./homelandingbg.png": 1349,
	"./icon-business.png": 190,
	"./icon-certificate.png": 191,
	"./icon-employee.png": 192,
	"./icon-training.png": 193,
	"./icon-vector1.png": 1350,
	"./icon-vector2.png": 1351,
	"./icon-vector3.png": 1352,
	"./icon-vector4.png": 1353,
	"./icon1.png": 1354,
	"./icon10.png": 1355,
	"./icon11.png": 1356,
	"./icon12.png": 1357,
	"./icon2.png": 1358,
	"./icon3.png": 1359,
	"./icon4.png": 1360,
	"./icon5.png": 1361,
	"./icon6.png": 1362,
	"./icon7.png": 1363,
	"./icon8.png": 1364,
	"./icon9.png": 1365,
	"./info-forgot-password-in.gif": 1366,
	"./info-journey-en.gif": 1367,
	"./info-journey.gif": 1368,
	"./info-new-mail.gif": 1369,
	"./info-password-security.gif": 1370,
	"./info-wifi.gif": 1371,
	"./it-gif1.gif": 1372,
	"./it-gif2.gif": 1373,
	"./it-gif3.gif": 1374,
	"./it-gif4.gif": 1375,
	"./it900-a031-en.jpg": 506,
	"./it900-a031.jpg": 507,
	"./it900-a32-1.jpg": 508,
	"./it900-a32-2.jpg": 509,
	"./it900-a32-3.jpg": 510,
	"./it930-a033-1.jpg": 511,
	"./it930-a033-2.jpg": 512,
	"./it930-a033-3.jpg": 513,
	"./it930-a033-4.jpg": 514,
	"./it930-a033-5-en.jpg": 515,
	"./it930-a033-5.jpg": 516,
	"./lady-right-01.png": 1376,
	"./lady-right.jpg": 517,
	"./lady-right.png": 1377,
	"./landingbg.png": 1378,
	"./logo.png": 1379,
	"./logo/consumer.png": 1380,
	"./logo/hkgcsmeaa.png": 1381,
	"./logo/logo.png": 1382,
	"./man-left-2.svg": 1383,
	"./man-right-2.png": 1384,
	"./man-right.jpg": 518,
	"./man-right2.png": 1385,
	"./man.jpg": 519,
	"./market-gif1.gif": 1386,
	"./market-gif2.gif": 1387,
	"./market-gif3.gif": 1388,
	"./market-gif4.gif": 1389,
	"./market-notpass.png": 194,
	"./market-quiz-info.png": 195,
	"./meeting.png": 1390,
	"./news-en.png": 1391,
	"./news-mobile-en.jpg": 520,
	"./news-mobile-sc.jpg": 521,
	"./news-mobile.jpg": 522,
	"./news-sc.jpg": 523,
	"./news.jpg": 524,
	"./news.png": 1392,
	"./next-icon.svg": 196,
	"./ngo-a035-1.jpg": 525,
	"./ngo-a035-2.jpg": 526,
	"./ngo-a035-3.jpg": 527,
	"./ngo-a035-4.jpg": 528,
	"./ngo-a036-example-en.png": 1393,
	"./ngo-a036-example.jpg": 529,
	"./ngo-gif1.gif": 1394,
	"./ngo-gif2.gif": 1395,
	"./ngo-gif3.gif": 1396,
	"./ngo-gif4.gif": 1397,
	"./notpass.png": 1398,
	"./office-risk1.png": 1399,
	"./office-risk2.png": 1400,
	"./office-risk3.png": 1401,
	"./office-risk4.png": 1402,
	"./office-risk5.png": 1403,
	"./org-brand1.png": 1404,
	"./ornament.png": 133,
	"./p-completed.svg": 1405,
	"./p-notstart.svg": 1406,
	"./p-onprogress-B.jpg": 530,
	"./p-onprogress-E-commerce.png": 1407,
	"./p-onprogress-b.png": 1408,
	"./p-onprogress-cs.png": 1409,
	"./p-onprogress-fsi.png": 1410,
	"./p-onprogress-g.png": 1411,
	"./p-onprogress-general2024.png": 1412,
	"./p-onprogress-it.png": 1413,
	"./p-onprogress-ngo.png": 1414,
	"./p-onprogress-startup.png": 1415,
	"./p-onprogress-student.png": 1416,
	"./p-onprogress.svg": 1417,
	"./p9801.png": 134,
	"./pass.png": 197,
	"./phishing-indentify1.png": 1418,
	"./phishing-indentify2.png": 1419,
	"./phishing-indentify3.png": 1420,
	"./phishing-indentify4-en.png": 1421,
	"./phishing-indentify4.png": 1422,
	"./phishing-indentify5.png": 1423,
	"./phishing-indentify6.png": 1424,
	"./phishing1.png": 1425,
	"./phishing2.png": 1426,
	"./phishing3.png": 1427,
	"./phishing4.png": 1428,
	"./phishingicon1.png": 1429,
	"./phishingicon2.png": 1430,
	"./phishingicon3.png": 1431,
	"./phishingicon4.png": 1432,
	"./plus.png": 83,
	"./popover-red.png": 1433,
	"./popover.png": 1434,
	"./popup1.png": 1435,
	"./prev-icon.svg": 1436,
	"./pwc-logo-dark.png": 1437,
	"./pwc-logo-dark.svg": 1438,
	"./pwc-logo-white.png": 1439,
	"./pwc-logo-white.svg": 1440,
	"./pwc-logo.png": 1441,
	"./pwc-logo.svg": 1442,
	"./quiz-icon.png": 113,
	"./quiz-info.png": 1443,
	"./quizbg.png": 1444,
	"./ransomewareRealcase-en.png": 1445,
	"./ransomewareRealcase-mobile-en.png": 1446,
	"./ransomewareRealcase-mobile.png": 1447,
	"./ransomewareRealcase.png": 1448,
	"./ransomware.png": 1449,
	"./results1.png": 1450,
	"./results2.png": 1451,
	"./results3.png": 1452,
	"./results4.png": 1453,
	"./s3-001.png": 1454,
	"./s3-002.png": 1455,
	"./s3-003.png": 1456,
	"./s3-004.jpg": 531,
	"./s3-005.jpg": 532,
	"./s3-006.jpg": 533,
	"./s3-007.jpg": 534,
	"./s3-008.jpg": 535,
	"./sample.png": 1457,
	"./secure-warning-bg.png": 1458,
	"./secure-warning1.png": 1459,
	"./secure-warning2.png": 1460,
	"./senior-sample1.png": 1461,
	"./senior-sample10.png": 1462,
	"./senior-sample2.png": 1463,
	"./senior-sample3-sc.png": 1464,
	"./senior-sample3.png": 1465,
	"./senior-sample4.png": 1466,
	"./senior-sample5.png": 1467,
	"./senior-sample6.png": 1468,
	"./senior-sample7.png": 1469,
	"./senior-sample8.png": 1470,
	"./senior-sample9.png": 1471,
	"./service.png": 198,
	"./small-icon1.png": 1472,
	"./small-icon10.png": 1473,
	"./small-icon2.png": 1474,
	"./small-icon3.png": 1475,
	"./small-icon4.png": 1476,
	"./small-icon5.png": 1477,
	"./small-icon6.png": 1478,
	"./small-icon7.png": 1479,
	"./small-icon8.png": 1480,
	"./small-icon9.png": 1481,
	"./social-media-bg-g.png": 1482,
	"./social-media-bg.png": 1483,
	"./social-media.gif": 55,
	"./socialMedia.png": 1484,
	"./sponsor-logo/1.png": 536,
	"./sponsor-logo/10.png": 537,
	"./sponsor-logo/11.png": 538,
	"./sponsor-logo/12.png": 539,
	"./sponsor-logo/13.png": 540,
	"./sponsor-logo/14.png": 541,
	"./sponsor-logo/15.png": 542,
	"./sponsor-logo/16.png": 543,
	"./sponsor-logo/17.png": 544,
	"./sponsor-logo/18.png": 545,
	"./sponsor-logo/19.png": 546,
	"./sponsor-logo/2.png": 547,
	"./sponsor-logo/20.png": 548,
	"./sponsor-logo/21.png": 549,
	"./sponsor-logo/22.png": 550,
	"./sponsor-logo/23.png": 551,
	"./sponsor-logo/24.png": 552,
	"./sponsor-logo/25.png": 553,
	"./sponsor-logo/26.png": 554,
	"./sponsor-logo/27.png": 555,
	"./sponsor-logo/28.png": 556,
	"./sponsor-logo/29.png": 557,
	"./sponsor-logo/3.png": 558,
	"./sponsor-logo/30.png": 559,
	"./sponsor-logo/4.png": 560,
	"./sponsor-logo/5.png": 561,
	"./sponsor-logo/6.png": 562,
	"./sponsor-logo/7.png": 563,
	"./sponsor-logo/8.png": 564,
	"./sponsor-logo/9.png": 565,
	"./sponsor-logo/more1.png": 566,
	"./startup1.gif": 1485,
	"./startup2.gif": 1486,
	"./startup3.gif": 1487,
	"./startup4.gif": 1488,
	"./startupRealCase1-en.jpg": 567,
	"./startupRealCase1-mobile-en.jpg": 568,
	"./startupRealCase1-mobile.jpg": 569,
	"./startupRealCase1.jpg": 570,
	"./startupRealCase2-en.jpg": 571,
	"./startupRealCase2-mobile-en.jpg": 572,
	"./startupRealCase2-mobile.jpg": 573,
	"./startupRealCase2.jpg": 574,
	"./step-c-1.png": 44,
	"./step-c-2.png": 45,
	"./step-c-3.png": 46,
	"./step-i-1.png": 1489,
	"./step-i-2.png": 1490,
	"./step-i-3.png": 1491,
	"./step-i-4.png": 1492,
	"./student.svg": 1493,
	"./student1.gif": 1494,
	"./student2.gif": 1495,
	"./student3.gif": 1496,
	"./student4.gif": 1497,
	"./studentRealCase1-en.png": 1498,
	"./studentRealCase1-mobile-en.png": 1499,
	"./studentRealCase1-mobile-sc.jpg": 575,
	"./studentRealCase1-mobile.png": 1500,
	"./studentRealCase1-sc.jpg": 576,
	"./studentRealCase1.png": 1501,
	"./studentRealCase2-en.png": 1502,
	"./studentRealCase2-mobile-en.png": 1503,
	"./studentRealCase2-mobile-sc.jpg": 577,
	"./studentRealCase2-mobile.png": 1504,
	"./studentRealCase2-sc.jpg": 578,
	"./studentRealCase2.png": 1505,
	"./support-org1.png": 1506,
	"./support-org2.png": 1507,
	"./support-org3.png": 1508,
	"./support-org4.png": 1509,
	"./test046.png": 1510,
	"./tip-arrow.png": 1511,
	"./tip1.png": 1512,
	"./tip2.png": 1513,
	"./tip3.png": 1514,
	"./tip4.png": 1515,
	"./tip5.png": 1516,
	"./tipbg.png": 1517,
	"./tips-person.png": 104,
	"./tips-person.svg": 1518,
	"./topic1.png": 1519,
	"./topic1200.png": 1520,
	"./topic1200bg.png": 1521,
	"./topic1400.png": 1522,
	"./topic1400bg.png": 1523,
	"./topic2.png": 1524,
	"./topic3.png": 1525,
	"./topic4.png": 1526,
	"./topic6.png": 1527,
	"./topic7.png": 1528,
	"./topic900.png": 1529,
	"./topic900bg.png": 1530,
	"./topic930.png": 1531,
	"./topic930bg.png": 1532,
	"./training-illustration.png": 1533,
	"./training-illustration10.png": 1534,
	"./training-illustration11.png": 1535,
	"./training-illustration12.png": 1536,
	"./training-illustration13.png": 1537,
	"./training-illustration2.png": 1538,
	"./training-illustration3.png": 1539,
	"./training-illustration4.svg": 1540,
	"./training-illustration5.svg": 1541,
	"./training-illustration6.svg": 1542,
	"./training-illustration7.png": 1543,
	"./training-illustration8.png": 1544,
	"./training-illustration9.png": 1545,
	"./transcrip.png": 199,
	"./unhappy-emoji.png": 95,
	"./useful-link-Icon.png": 1546,
	"./vector.png": 1547,
	"./vector137.png": 1548,
	"./video1-en.mp4": 1549,
	"./video1.mp4": 1550,
	"./video1more.mp4": 1551,
	"./video2.mp4": 1552,
	"./warning-alert-bg.png": 1553,
	"./warning-alert-bg2.png": 1554,
	"./welc1.gif": 1555,
	"./welc2.gif": 1556,
	"./welc3.gif": 1557,
	"./welc4.gif": 1558,
	"./welcome.gif": 1559,
	"./welcomeInfo.png": 1560,
	"./welcomeInfo2.png": 1561,
	"./welcomeInfo3.png": 1562,
	"./welcomeLandingbg-E-commerce.png": 1563,
	"./welcomeLandingbg-fsi.png": 1564,
	"./welcomeLandingbg-general2024.png": 1565,
	"./welcomeLandingbg-it.png": 1566,
	"./welcomeLandingbg-ngo.png": 1567,
	"./welcomeLandingbg-startup.png": 1568,
	"./welcomeLandingbg-student.png": 1569,
	"./welcomeLandingbg.png": 1570,
	"./whatsApp.png": 1571,
	"./whatsAppRealcase-en-mobile.png": 1572,
	"./whatsAppRealcase-en.png": 1573,
	"./whatsAppRealcase-mobile.png": 1574,
	"./whatsAppRealcase.png": 1575,
	"./working.png": 1576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5;